import { render } from "./Pager.vue?vue&type=template&id=62ae2378"
import script from "./Pager.vue?vue&type=script&lang=js"
export * from "./Pager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__